import angular from 'angular';

function PermissionDisabledDirective($compile, permissionService, $stateParams) {
  return {
    restrict: 'A',
    scope: {
      permissionDisabled: '=',
      permissionDisabledParams: '='
    },
    link: function (scope, element) {
      element.attr('ng-disabled', 'disabled');
      element.removeAttr('permission-disabled');

      hasPermission(scope.permissionDisabled, scope.permissionDisabledParams)
        .then(hasP => {
          element.attr('disabled', !hasP);
        });

      function hasPermission(permissionFnName, permissionFnParams) {
        if (!permissionFnName) throw new Error('permissionDisabled - hasPermission - permissionFnName is required');

        const permissionFn = permissionService[permissionFnName];

        if (!permissionFn) throw new Error(`permissionDisabled - hasPermission - ${permissionFnName} is not a valid permission handler`);

        const params = [];

        if (permissionFnParams) {
          angular.forEach(permissionFnParams, param => {
            if ($stateParams[param]) {
              params.push($stateParams[param]);
            }
          });
        }

        return permissionFn.apply(permissionService, params);
      }
    }
  };
}

PermissionDisabledDirective.$inject = [
  '$compile',
  'permissionService',
  '$stateParams'
];

export default PermissionDisabledDirective;



// WEBPACK FOOTER //
// ./src/directives/permissionDisabled.js